import * as React from "react";

import ComponentPage from "../../Components/ComponentPage";
import Usage from "../../Docs/Components/Status/StatusUsage.mdx";

import Examples from "../../Docs/Components/Status/StatusExamples";
        
class Page extends React.Component {
public render() {
    return (
        <ComponentPage
            name="Status"
            description="Status conveys the state of an item or object in a visual manner."
            apiSources={["azure-devops-ui/Components/Status/Status.Props.d.ts"]}
            examples={Examples}
            internalLinks={{"figma":"https://www.figma.com/file/fGDcHLimUgJFQVRAFB6SjQ/Status?node-id=75%3A8"}}
            status={{"design":"done","code":"done","docs":"Planned (Q3)"}}
            usage={Usage}
        />
    );
}
}
        
export default Page;